import { PropsWithChildren } from 'react';
import cns from 'classnames';
import { useTranslation } from 'next-i18next';
import { useAuth } from '@zep/auth';
import { logger } from '@zep/core-logger';
import { CurrencyWonCircleFillIcon, CurrencyYenCircleFillIcon, ZemColorIcon } from '@zep/icons';
import { ChargeZemItem, Currency } from '@zep/types';
import { Colors } from '@zep/ui-tokens';
import { ChargeZemStep, useChargeZem } from '../ZemChargeContext';
import { ChargeContainer } from './ChargeContainer';
import S from './ZemSelectStep.module.scss';
export const ZemSelectStep = () => {
  const {
    t
  } = useTranslation(['manage']);
  const {
    handleStep,
    selectedZemInfo
  } = useChargeZem();
  const nextStep = () => {
    logger.track('charge_zem_button', {
      amount: selectedZemInfo.addCashMoney
    });
    handleStep(ChargeZemStep.Payment);
  };
  return <>
      <ChargeContainer title={t('manage:donate_charge_zem')} content={<Content />} mainAction={nextStep} data-sentry-element="ChargeContainer" data-sentry-source-file="ZemSelectStep.tsx" />
    </>;
};
const Content = () => {
  const {
    t
  } = useTranslation(['manage']);
  const {
    user
  } = useAuth();
  const {
    zemItems
  } = useChargeZem();
  return <div className={S.container} data-sentry-component="Content" data-sentry-source-file="ZemSelectStep.tsx">
      <div className={S.owner_zem}>
        <div className={S.owner_zem_lable}>
          {t('manage:donate_current_zem')}
        </div>
        <div className={S.owner_zem_value}>
          <div className={S.owner_zem_row}>
            <span>{Number(user?.totalCashMoney).toLocaleString()} </span>
            <ZemColorIcon width={20} height={20} data-sentry-element="ZemColorIcon" data-sentry-source-file="ZemSelectStep.tsx" />{' '}
          </div>
        </div>
      </div>
      <ZemCardContainer data-sentry-element="ZemCardContainer" data-sentry-source-file="ZemSelectStep.tsx">
        {zemItems.map((d, index) => <ZemCard key={d.id} index={index} {...d} />)}
      </ZemCardContainer>
    </div>;
};
const ZemCardContainer = (props: PropsWithChildren) => {
  return <div className={S.card_container} data-sentry-component="ZemCardContainer" data-sentry-source-file="ZemSelectStep.tsx">{props.children}</div>;
};
const ZemCard = (props: ChargeZemItem & {
  index: number;
  price: number;
}) => {
  const {
    zem,
    handleZem: _handleZem,
    currency
  } = useChargeZem();
  const handleZem = () => {
    _handleZem(props.addCashMoney);
  };
  const selected = zem === props.addCashMoney;
  return <div className={cns(S.card, {
    [S.selected]: selected
  })} onClick={handleZem} data-sentry-component="ZemCard" data-sentry-source-file="ZemSelectStep.tsx">
      <div className={S.card_content}>
        <div className={S.card_wrapper}>
          <img src={`/images/zems/zem_v2_${props.index > 7 ? 7 : props.index}.png`} className={S.card_image} alt="zem_icon" />
        </div>
        <div className={S.card_title}>
          {props.addCashMoney.toLocaleString()} ZEM
        </div>
      </div>
      <ZemPriceLabel price={props.price} currency={currency} selected={selected} data-sentry-element="ZemPriceLabel" data-sentry-source-file="ZemSelectStep.tsx" />
    </div>;
};
const ZemPriceLabel = ({
  price,
  selected,
  currency
}: {
  price: number;
  selected: boolean;
  currency: Currency;
}) => {
  const fill = selected ? Colors.PrimaryDefault : Colors.Gray500;
  const color = selected ? Colors.PrimaryDefault : Colors.Gray600;
  const iconProps = {
    fill,
    width: 16,
    height: 16
  };
  return <div className={S.card_label} data-sentry-component="ZemPriceLabel" data-sentry-source-file="ZemSelectStep.tsx">
      {currency === 'KRW' ? <CurrencyWonCircleFillIcon {...iconProps} /> : currency === 'JPY' ? <CurrencyYenCircleFillIcon {...iconProps} /> : <span style={{
      alignItems: 'center',
      color,
      display: 'inline-flex',
      fontSize: 13,
      height: 16,
      justifyContent: 'center',
      lineHeight: '16px',
      width: 16
    }}>
          $
        </span>}
      <div style={{
      color
    }}>{price.toLocaleString()}</div>
    </div>;
};